// /admin/v1/dashboard/* — KPI tiles.

import { get } from './client';

export interface AppSummary {
  app_id: number;
  range: { from: string; to: string };
  dau_avg?: number;
  new_users_total?: number;
  d1_retention_pct?: number;
  d7_retention_pct?: number;
  d30_retention_pct?: number;
  gmv_cents?: number;
  arpu_cents?: number;
  roas?: number;
  repeat_pay_rate?: number;
  share_rate?: number;
  inference_cost_cny?: number;
}

export function getAppSummary(
  appId: number,
  from: string,
  to: string,
): Promise<AppSummary> {
  return get<AppSummary>(`/admin/v1/dashboard/app/${appId}/summary`, { from, to });
}

export interface PlatformSummary {
  active_apps: number;
  total_users: number;
  cross_app_user_pct?: number;
  cross_app_diamond_flow_pct?: number;
  /** Per-app stats. */
  apps?: Array<{
    app_id: number;
    app_slug: string;
    app_name?: string;
    dau_avg?: number;
    gmv_cents?: number;
    new_users_total?: number;
    roas?: number;
  }>;
}

export function getPlatformSummary(from?: string, to?: string): Promise<PlatformSummary> {
  return get<PlatformSummary>('/admin/v1/dashboard/platform', { from, to });
}
